import { css } from '@emotion/css'
import {
  spacing,
  fontWeight,
  fontSize,
  fontFamily,
  breakpoint,
  shorthandHelper,
  mediaQueryHelper,
  colors,
  hexToRgba,
  lineHeight,
} from '@offerzen/pinata-shame'

const styles = {
  navigation: css({
    height: '100%',
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    alignItems: 'stretch',
  }),

  link: css({
    boxSizing: 'border-box',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    color: hexToRgba(colors.white, 0.6),
    textDecoration: 'none',
    borderTop: '2px solid transparent',
    borderBottom: '2px solid transparent',
    transition: 'color 0.2s',
    margin: shorthandHelper([0, spacing.small]),

    '&:hover': {
      color: colors.white,
    },

    '&:focus': {
      color: colors.white,
    },

    [mediaQueryHelper(breakpoint.tablet)]: {
      margin: shorthandHelper([0, spacing.default]),
    },

    [mediaQueryHelper(breakpoint.desktop)]: {
      margin: shorthandHelper([0, spacing.medium]),
    },
  }),

  activeLink: css({
    fontWeight: fontWeight.semiBold,
    color: colors.white,
    borderBottomColor: colors.cornflowerBlue,
  }),

  dropdown: css({
    marginLeft: spacing.small,
    height: '100%',
    display: 'flex',
    alignItems: 'center',

    [mediaQueryHelper(breakpoint.tablet)]: {
      marginLeft: spacing.default,
    },

    [mediaQueryHelper(breakpoint.desktop)]: {
      marginLeft: spacing.medium,
    },

    '& > button': {
      borderTop: '2px solid transparent',
      borderBottom: '2px solid transparent',
      opacity: 0.6,
      transition: 'color 0.2s',
      alignSelf: 'center',
      height: '100%',

      '&:hover': {
        opacity: 1,
      },
    },
  }),

  navButton: css({
    backgroundColor: 'transparent',
    borderColor: 'transparent',
    border: 'none',
    padding: 0,
    fontSize: fontSize.default,
    fontFamily: fontFamily.body,
    color: `${hexToRgba(colors.white, 0.6)} !important`,
    lineHeight: lineHeight.default,
    cursor: 'pointer',

    '&:hover': {
      color: `${colors.white} !important`,
    },

    '&:focus': {
      color: `${colors.white} !important`,
    },
  }),
}

export default styles
